import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { AnalyticsGranularity } from '../interfaces/analytics';
import { buildQueryString } from '@mm/utils';

export default class AnalyticsController extends AuthenticatedController {
  static getAll(
    botId: number,
    startDate: string,
    endDate: string,
    granularity: AnalyticsGranularity,
    filter?: string,
  ) {
    const queryString = buildQueryString({
      granularity,
      start_date: startDate,
      end_date: endDate,
      filter,
    });

    return super.get(`${APIRoutes.BOTS}/${botId}/analytic_page${queryString}`);
  }
}
